// ProfileInfoEditor.js
import { connect } from 'react-redux';
import ProfileInfoEditor from '../component/ProfileInfoEditor.jsx';

import setProfileInfoDraft from '../action/setProfileInfoDraft.js';
import submitProfileInfo from '../action/submitProfileInfo.js';
import removeModals from '../action/removeModals.js';
import addModal from '../action/addModal.js';

import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import {
  getUserPicture,
  getUserBackground,
  MediaAssetFormat,
} from '../resource/getMediaAsset.js';

const blobUrl = src => {
  if (src instanceof File) {
    return URL.createObjectURL(src);
  }
  return src;
};

const mapStateToProps = state => {
  const meId = getMeData(state, 'id');
  const meBackground = getMeData(state, 'background');
  const mePicture = getMeData(state, 'picture');
  const meBiography = getMeData(state, 'biography');
  const remoteBackground = getUserBackground({
    userId: meId,
    meId,
    size: 1024,
    format: MediaAssetFormat.JPG,
  }).href;
  const remotePicture = getUserPicture({
    userId: meId,
    meId,
    size: 512,
    format: MediaAssetFormat.JPG,
  }).href;
  const isBiographyFetching = getNetworkingData(
    state,
    ['patch', 'me'],
    'isFetching'
  );
  return {
    remoteBackground,
    remotePicture,
    username: getMeData(state, 'username'),
    meBackground,
    mePicture,
    meBiography,
    backgroundDraft: blobUrl(
      getOperationData(state, ['myProfileInfoDraft'], 'background')
    ),
    pictureDraft: blobUrl(
      getOperationData(state, ['myProfileInfoDraft'], 'picture')
    ),
    biographyDraft: getOperationData(
      state,
      ['myProfileInfoDraft'],
      'biography'
    ),
    pictureIsChanged: getOperationData(
      state,
      ['myProfileInfoDraft'],
      'picture:isChanged'
    ),
    backgroundIsChanged: getOperationData(
      state,
      ['myProfileInfoDraft'],
      'background:isChanged'
    ),
    biographyIsChanged: getOperationData(
      state,
      ['myProfileInfoDraft'],
      'biography:isChanged'
    ),
    isBiographyFetching,
  };
};

const mapDispatchToProps = dispatch => ({
  closeInfoEditor: () => {
    dispatch(
      removeModals({
        ids: ['ProfileInfoEditor'],
        transitionStatus: 'closing',
      })
    );
  },
  openDraftDropAlert: () => dispatch(addModal({ id: 'DraftsDropAlert' })),
  openProfileImageUploadModal: ({ type }) =>
    dispatch(
      addModal({
        id:
          type === 'picture'
            ? 'ProfileAvatarPreviewAndCropModal'
            : 'ProfileCoverPreviewAndCropModal',
        transitionStatus: 'coming',
        isHigherThanAll: true,
      })
    ),
  setProfileInfoDraft: payload =>
    dispatch(setProfileInfoDraft({ ...payload, type: 'update' })),
  submitProfileInfo: () => dispatch(submitProfileInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileInfoEditor);
